(() => {
  'use strict';
  const key = 'gm-navigation-v1';
  const toolbar = document.querySelector('[data-gm-navigation]');
  const back = document.querySelector('[data-gm-navigation-link]') || toolbar?.querySelector('a');
  // Track the visible edge of the auto-hiding header, independently of page content.
  if (toolbar && back) {
    const header = document.querySelector('.section-header');
    let positionFrame;
    const positionBack = () => {
      positionFrame = null;
      const bottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      back.style.setProperty('--gm-back-header-bottom', Math.round(bottom) + 'px');
    };
    const schedulePosition = () => {
      if (!positionFrame) positionFrame = requestAnimationFrame(positionBack);
    };
    addEventListener('scroll', schedulePosition, { passive: true });
    addEventListener('resize', schedulePosition, { passive: true });
    addEventListener('pageshow', schedulePosition);
    if (header) {
      new MutationObserver(schedulePosition).observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
      if ('ResizeObserver' in window) new ResizeObserver(schedulePosition).observe(header);
      header.addEventListener('transitionend', schedulePosition);
    }
    positionBack();
  }
  const identity = value => { const u = new URL(value, location.href); return u.origin + u.pathname + u.search + u.hash; };
  const internal = value => { try { return new URL(value, location.href).origin === location.origin; } catch { return false; } };
  let db;
  try { db = JSON.parse(sessionStorage.getItem(key)) || {}; } catch { db = {}; }
  db.entries ||= {};
  const now = Date.now();
  for (const [id, entry] of Object.entries(db.entries)) if (now - entry.time > 86400000 || !internal(entry.url)) delete db.entries[id];
  const ids = Object.keys(db.entries).sort((a,b) => db.entries[b].time - db.entries[a].time);
  ids.slice(50).forEach(id => delete db.entries[id]);
  const save = () => { try { sessionStorage.setItem(key, JSON.stringify(db)); } catch {} };
  const push = history.pushState.bind(history), replace = history.replaceState.bind(history);
  let id = history.state?.gmNavId;
  if (!id || !db.entries[id]) {
    id = crypto.randomUUID();
    const pending = db.pending;
    const referrer = internal(document.referrer) && document.referrer ? new URL(document.referrer) : null;
    const prior = referrer ? Object.entries(db.entries).filter(([,entry]) => {
      const url = new URL(entry.url); return url.origin + url.pathname + url.search === referrer.origin + referrer.pathname + referrer.search;
    }).sort((a,b) => b[1].time - a[1].time)[0]?.[0] : null;
    const previous = history.length > 1 ? (pending && now - pending.time < 30000 && identity(pending.url) === identity(location.href) ? pending.from : prior) : null;
    db.entries[id] = { url: location.href, previous, steps: 1, x: 0, y: 0, time: now };
    delete db.pending;
    replace({ ...history.state, gmNavId: id }, '');
  }
  let restoring = false, cancelRestore = () => {}, captureFrame;
  function capture() {
    if (restoring || !db.entries[id]) return;
    const detail = {};
    document.dispatchEvent(new CustomEvent('gm:navigation:capture', { detail }));
    Object.assign(db.entries[id], { url: location.href, x: scrollX, y: scrollY, portfolio: detail.portfolio, time: Date.now() });
    save();
  }
  function fallback() {
    const root = window.Shopify?.routes?.root || '/';
    const path = root !== '/' && location.pathname.startsWith(root) ? '/' + location.pathname.slice(root.length) : location.pathname;
    if (path.startsWith('/pages/projekt-')) return '/pages/design-dit-eget-smykke?view=gem-portfolio';
    if (path.startsWith('/products/')) return '/collections/alle-smykker';
    if (path.startsWith('/collections/')) return path === '/collections/alle-smykker' ? '/' : '/collections/alle-smykker';
    if (path.startsWith('/pages/') && path !== '/pages/design-dit-eget-smykke') return '/pages/design-dit-eget-smykke';
    return path === '/' ? '/collections/alle-smykker' : '/';
  }
  function themeUrl(value) {
    const url = new URL(value, location.href);
    const root = window.Shopify?.routes?.root || '/';
    if (root !== '/' && !url.pathname.startsWith(root)) url.pathname = root.replace(/\/$/, '') + url.pathname;
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview && !url.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', preview);
    return url.href;
  }
  function refreshBack() {
    if (!back) return;
    const previous = db.entries[db.entries[id]?.previous];
    back.href = themeUrl(previous?.url || fallback());
    back.dataset.gmHistoryBack = previous ? 'true' : 'false';
  }
  function restore() {
    const entry = db.entries[id];
    if (!entry || identity(entry.url) !== identity(location.href)) return;
    cancelRestore();
    restoring = true;
    document.dispatchEvent(new CustomEvent('gm:navigation:restore', { detail: entry.portfolio }));
    const start = performance.now();
    let frame, observer, settled = 0, lastHeight = -1;
    const stop = () => {
      cancelAnimationFrame(frame); observer?.disconnect(); restoring = false;
      for (const type of ['wheel','touchstart','pointerdown','keydown']) window.removeEventListener(type, stop, true);
    };
    cancelRestore = stop;
    for (const type of ['wheel','touchstart','pointerdown','keydown']) window.addEventListener(type, stop, { capture: true, passive: true, once: true });
    const position = () => {
      const height = document.documentElement.scrollHeight;
      scrollTo({ left: entry.x || 0, top: entry.y || 0, behavior: 'instant' });
      settled = height === lastHeight && Math.abs(scrollY - (entry.y || 0)) < 2 ? settled + 1 : 0;
      lastHeight = height;
      if (performance.now() - start > 4000 || (settled > 12 && performance.now() - start > 700)) { stop(); return; }
      frame = requestAnimationFrame(position);
    };
    if ('ResizeObserver' in window) { observer = new ResizeObserver(() => { settled = 0; }); observer.observe(document.body); }
    frame = requestAnimationFrame(position);
  }
  history.scrollRestoration = 'manual';
  history.pushState = function(state, title, url) {
    capture();
    const previous = id, outgoing = db.entries[id]; id = crypto.randomUUID();
    push({ ...state, gmNavId: id }, title, url);
    const samePage = outgoing && new URL(outgoing.url).pathname === location.pathname;
    db.entries[id] = { url: location.href, previous: samePage ? outgoing.previous : previous, steps: samePage ? (outgoing.steps || 1) + 1 : 1, x: scrollX, y: scrollY, time: Date.now() };
    save(); refreshBack();
  };
  history.replaceState = function(state, title, url) {
    replace({ ...state, gmNavId: id }, title, url);
    if (db.entries[id]) { db.entries[id].url = location.href; save(); }
  };
  back?.addEventListener('click', event => {
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || back.dataset.gmHistoryBack !== 'true') return;
    event.preventDefault(); capture(); history.go(-(db.entries[id]?.steps || 1));
  });
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self') || !internal(link.href)) return;
    const target = new URL(link.href);
    if (!/^https?:$/.test(target.protocol) || (target.pathname === location.pathname && target.search === location.search && target.hash)) return;
    capture(); db.pending = { from: id, url: target.href, time: Date.now() }; save();
  });
  addEventListener('scroll', () => { if (!captureFrame) captureFrame = requestAnimationFrame(() => { captureFrame = null; capture(); }); }, { passive: true });
  addEventListener('pagehide', capture);
  addEventListener('popstate', () => {
    id = history.state?.gmNavId;
    if (!db.entries[id]) { id = crypto.randomUUID(); db.entries[id] = { url: location.href, x: 0, y: 0, time: Date.now() }; replace({ ...history.state, gmNavId: id }, ''); }
    refreshBack(); restore();
  });
  addEventListener('pageshow', () => { refreshBack(); restore(); });
  document.addEventListener('gm:navigation:ready', () => { if (db.entries[id]?.portfolio) restore(); });
  refreshBack(); save();
})();